import { Component, Prop } from 'vue-property-decorator'
import {
    KhAvatarGroup,
    InitialNameRenderMethod,
    KhAvatarItem,
    KhAnimationProps,
} from '@internal-libraries/kheops-ui-lib'
import { KhText } from '@internal-libraries/kheops-ui-lib'
import { User } from '../../../../../../admin/vue/classes/User'
import ClvrScreenControlCellAbstract from '../ClvrScreenControlCellAbstract'
import { DEFAULT_TEXT_ANIMATION_RIGHT_TO_LEFT } from '../../const'
import { DEFAULT_HEIGHT_CONTAINER } from '../../../../const'
import ScreenResolutionHelper from '../../../../../../system/vue/Classes/ScreenResolutionHelper'

@Component({
    components: {
        KhAvatarGroup,
        KhText,
    },
})
export default class ClvrScreenControlOperatingRoomStaff extends ClvrScreenControlCellAbstract {
    @Prop({ type: Array, default: () => [] })
    public users!: User[]
    @Prop({ type: Boolean, default: false })
    public useAvatar!: boolean

    public initialNameMethod = (user: User, labelPart?: number) => {
        return user.initials?.slice(0, 3) ?? InitialNameRenderMethod(user.fullName, labelPart)
    }

    public get animationProps(): KhAnimationProps {
        return {
            ...DEFAULT_TEXT_ANIMATION_RIGHT_TO_LEFT,
            text: this.userNames,
            containerHeight: ScreenResolutionHelper.getSizeFor4KResolution(DEFAULT_HEIGHT_CONTAINER),
        }
    }

    public get avatarUsers(): KhAvatarItem<User>[] {
        return this.users.map(user => {
            return {
                data: user,
                color: user.color,
            }
        })
    }

    public get userNames(): string {
        return this.users.map(user => user.fullName).join(', ') || ''
    }
}
